var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssessmentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5118 14.589C11.2904 14.811 10.9845 14.9489 10.646 14.9489C9.97157 14.9489 9.42468 14.402 9.42468 13.7275C9.42468 13.3915 9.56066 13.0873 9.7805 12.8663V12.8661L9.7824 12.8642C9.78267 12.8639 9.78267 12.8636 9.78295 12.8636L12.1985 10.4356C11.7037 10.1995 11.1522 10.0635 10.5673 10.0635C8.46905 10.0635 6.76758 11.7655 6.76758 13.8632C6.76758 15.9609 8.46905 17.663 10.5673 17.663C12.6656 17.663 14.3671 15.9609 14.3671 13.8632C14.3671 13.2417 14.2145 12.6565 13.9499 12.1384L11.5118 14.589Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 3.61004L21.495 3.35953L22.0802 2.76921C22.2384 2.60962 22.2373 2.35178 22.0774 2.19355C21.9179 2.03532 21.66 2.0364 21.5018 2.19626L20.9286 2.77464L20.68 0.289062L16.0008 4.96899V7.74687L10.2507 13.5491C10.0925 13.7087 10.0936 13.9665 10.2535 14.1247C10.413 14.283 10.6709 14.2819 10.8291 14.122L16.6099 8.28888H19.3221L24.0004 3.61004Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6589 9.10622H19.3216H16.9706L16.3108 9.76927C17.1367 10.9249 17.6244 12.3384 17.6244 13.8668C17.6244 17.7637 14.4644 20.9237 10.5678 20.9237C6.67113 20.9237 3.5111 17.7637 3.5111 13.8668C3.5111 9.97039 6.67113 6.81036 10.5678 6.81036C12.054 6.81036 13.4322 7.27094 14.5697 8.05613L15.1861 7.4365V4.9721V4.64614C13.7962 3.94861 12.2285 3.55371 10.5675 3.55371C4.87222 3.55371 0.253906 8.17148 0.253906 13.867C0.253906 19.5631 4.87222 24.1809 10.5675 24.1809C16.2633 24.1809 20.8811 19.5631 20.8811 13.867C20.8811 12.1341 20.4514 10.5024 19.6964 9.06849L19.6589 9.10622Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentActive);
export default __webpack_public_path__ + "static/media/assessment-active.e36c029ff9bffcb708735626d5703971.svg";
export { ForwardRef as ReactComponent };